import webDevelopment from '@public/webDev.jpg';
import uiuxdesign from '@public/uiuxdesign.jpg';
import ecommerce from '@public/ecommerce.jpg';
import seo from '@public/seo.jpg';
import performance from '@public/performanceOptimization.svg';
import maintenenceAndSupport from '@public/maintenenceAndSupport.jpg';
import api from '@public/api.jpg';
import customeSoftware from '@public/customeSoftware.jpg';
import redesign from '@public/redesign.svg';

const carouselConfig = [
  {
    imgUrl: webDevelopment.src,
    title: 'Web Development',
    description:
      'We build fast, scalable, and secure websites tailored to your business needs.',
    details:
      'Custom web applications, CMS-based websites, full-stack development, API integration, etc.',
  },
  {
    imgUrl: uiuxdesign.src,
    title: 'UI/UX Design',
    description:
      'Creating beautiful, user-friendly interfaces that deliver exceptional digital experiences.',
    details:
      'User research, wireframing, prototyping, user testing, responsive design, interaction design.',
  },
  {
    imgUrl: ecommerce.src,
    title: 'E-Commerce Solutions',
    description:
      'Developing secure and easy-to-use e-commerce platforms designed to boost your online sales.',
    details:
      'Custom-built e-commerce sites, Shopify, WooCommerce or Payload setups, payment gateway integration, product catalog management, etc.',
  },
  {
    imgUrl: seo.src,
    title: ' SEO & Digital Marketing',
    description:
      'Optimizing your website for search engines to drive traffic and improve your online presence.',
    details:
      'SEO audits, keyword research, on-page SEO, technical SEO, content optimization, Google Analytics setup, etc.',
  },
  {
    imgUrl: performance.src,
    title: 'Performance Optimization',
    description:
      'Enhancing the speed and performance of your website for better user experience and search engine rankings.',
    details:
      'Speed optimization, image compression, lazy loading, code refactoring, and server-side rendering (SSR).',
  },
  {
    imgUrl: maintenenceAndSupport.src,
    title: 'Maintenance & Support',
    description:
      'Providing ongoing maintenance and support to keep your website secure, up-to-date, and running smoothly.',
    details:
      'Website updates, bug fixes, security patches, ongoing support, performance monitoring, backups.',
  },
  // {
  //   imgUrl: cloudhostinganddeployment.src,
  //   title: 'Cloud Hosting & Deployment',
  //   description:
  //     'Offering reliable and scalable cloud hosting solutions to ensure your website performs at its best.',
  //   details:
  //     'AWS, Google Cloud, Vercel and Azure deployment,  server management, continuous integration (CI/CD), monitoring, and uptime management.',
  // },
  {
    imgUrl: api.src,
    title: 'API Development & Integration',
    description:
      'Seamlessly integrating third-party services to expand your website’s functionality.',
    details:
      'RESTful API development, third-party API integration (payment gateways, CRM, ERP, etc.), custom API solutions.',
  },
  {
    imgUrl: customeSoftware.src,
    title: 'Custom Software Solutions',
    description:
      'Developing custom software solutions to automate your business processes and improve efficiency.',
    details:
      'Tailored software applications, enterprise-level solutions, SaaS products, internal tools, etc.',
  },
  {
    imgUrl: redesign.src,
    title: 'Website Redesign & Revamp',
    description:
      'Giving your website a fresh, modern look while improving functionality and user experience.',
    details:
      'Website redesign, user experience upgrades, content restructuring, performance enhancements.',
  },
];

export default carouselConfig;
